import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('token') || null,
    username: localStorage.getItem('username') || '',
    role: localStorage.getItem('role') || '', // 直接使用存储的角色
    isAuthenticated: !!localStorage.getItem('token')
  }),
  actions: {
    login(credentials) {
      try {
        const { token, username, role } = credentials;

        this.token = token;
        this.username = username;
        this.role = role; // 直接设置角色
        localStorage.setItem('token', token);
        localStorage.setItem('username', username);
        localStorage.setItem('role', role);
        this.isAuthenticated = true;

        return credentials;
      } catch (error) {
        this.logout();
        throw error;
      }
    },
    // 确保logout方法完整
    logout() {
      this.token = null;
      this.username = '';
      this.role = '';
      this.isAuthenticated = false;
      // 确保清除所有认证相关数据
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      localStorage.removeItem('role');
      localStorage.removeItem('remember');
    },
    isAdmin() {
      return this.role === 'admin';
    },
    isTeacher() {
      return this.role === 'teacher';
    },
    isStudent() {
      return this.role === 'student';
    }
  }
});